import React from 'react';

import type { IconProps } from '../../icon-types';
import { IconBase } from '../../IconBase';

export const ExternalLinkIcon = React.forwardRef<SVGSVGElement, IconProps>(function ExternalLinkIcon(props, ref) {
    return (
        <IconBase ref={ref} viewBox="0 0 24 24" {...props}>
            <path fill="currentColor" d="M19 19H5V5h7V3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7h-2zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3z"/>
        </IconBase>
    );
});
